/* eslint-disable id-blacklist */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-bitwise */
import { Injectable } from '@angular/core';
import { ReplaySubject, Observable, of } from 'rxjs';

import { AuthProfile } from '../../models/auth-profile';
import { config } from '../../../assets/config-constants';


@Injectable()
export class OnboardAuthService {
  private _profile: ReplaySubject<AuthProfile> = new ReplaySubject<AuthProfile>();
  public profile: Observable<AuthProfile> = this._profile.asObservable();

  private _issuer: string;
  private _state: string;

  constructor() {
    this.setAuth();
  }

  setAuth(token?: string) {
    if (token) {
      localStorage.setItem('access_token', token);
    }
    of(localStorage.getItem('access_token')).subscribe((access_token) => {
      if (access_token) {
        const profile = this._extractIdToken(access_token);

        if (!profile) {
          return;
        }
        if (!profile[config.claimUserMetadata]) {
          profile[config.claimUserMetadata] = {
            first_name: '',
            last_name: '',
          };
        } else {
          if (!profile[config.claimUserMetadata].first_name) {
            profile[config.claimUserMetadata].first_name = '';
          }
          if (!profile[config.claimUserMetadata].last_name) {
            profile[config.claimUserMetadata].last_name = '';
          }
        }
        if(!profile[config.claimCompanyId]){
          profile[config.claimCompanyId] = '';
        }
        if(!profile[config.claimCompanyName]){
          profile[config.claimCompanyName] = '';
        }
        this._issuer = profile['iss'];
        this._profile.next(profile);
      }
    });
  }

  setState(state: string) {
    this._state = state;
  }

  finish() {
    window.location.href = `${this._issuer}continue?state=${this._state}`;
  }

  /////// token decoding functions /////////////
  private _extractIdToken(encodedIdToken: any) {
    // id token will be decoded to get the username
    const decodedToken = this._decodeJwt(encodedIdToken);
    if (!decodedToken) {
      return null;
    }

    try {
      const base64IdToken = decodedToken.JWSPayload;
      const base64Decoded = this._base64DecodeStringUrlSafe(base64IdToken);
      if (!base64Decoded) {
        console.log(
          'The returned id_token could not be base64 url safe decoded.'
        );
        return null;
      }

      // ECMA script has JSON built-in support
      return JSON.parse(base64Decoded);
    } catch (err) {
      console.log('The returned id_token could not be decoded', err);
    }

    return null;
  }

  private _decodeJwt(jwtToken: any) {
    if (this._isEmpty(jwtToken)) {
      return null;
    }

    const idTokenPartsRegex = config.idTokenPartsRegex;

    const matches = idTokenPartsRegex.exec(jwtToken);
    if (!matches || matches.length < 4) {
      console.log('The returned id_token is not parseable.');
      return null;
    }

    const crackedToken = {
      header: matches[1],
      JWSPayload: matches[2],
      JWSSig: matches[3],
    };

    return crackedToken;
  }

  private _isEmpty(str: any) {
    return typeof str === 'undefined' || !str || 0 === str.length;
  }

  private _decimalToHex(number: any) {
    let hex = number.toString(16);
    while (hex.length < 2) {
      hex = '0' + hex;
    }
    return hex;
  }

  // https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
  private _b64DecodeUnicode(str) {
    return decodeURIComponent(
      Array.prototype.map
        // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
        .call(atob(str), function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }

  private _base64DecodeStringUrlSafe(base64IdToken: any) {
    base64IdToken = base64IdToken.replace(/-/g, '+').replace(/_/g, '/');
    return decodeURIComponent(encodeURI(this._b64DecodeUnicode(base64IdToken))); // jshint ignore:line
  }
}
